<template>
  <div>
    <b-row align-v="stretch">
      <b-col class="px-0 col-12 col-lgx-6">
        <div class="mr-lgx-2 d-flex flex-column h-100">
          <h3 class="mt-2 pt-4 text-left">
            <b-icon
              icon="envelope"
              variant="secondary"
              font-scale="1.2"
              class="mr-1"
            ></b-icon>
            {{$t('AccessoEPermessi.datiAccesso')}}
          </h3>
          <section
            class="bg-white general_border shadowedCard p-2 p-md-3 p-lg-4 h-100"
          >
            <p
              v-if="user.temporary_password"
              class="text-left mb-1 text-danger"
            >
              {{$t('AccessoEPermessi.modificaPasswordTemporanea')}}
            </p>
            <p v-if="user.expired_password" class="text-left mb-1 text-danger">
              {{$t('AccessoEPermessi.passwordScaduta')}}
            </p>
            <div ref="changePasswordDiv" class="col-12 d-flex flex-wrap px-0">
              <!-- <b-form-group
                label="Email"
                label-for="email"
                class="text-left fs-6 mx-auto col-12 col-lg-6"
              >
                <b-form-input
                  class="my-3 "
                  name="email"
                  type="text"
                  readonly
                  v-model="user.email"
                ></b-form-input>
              </b-form-group> -->
              <b-form-group
                label="Username"
                label-for="email"
                class="text-left mx-auto col-12 col-lg-6"
              >
                <b-form-input
                  class="my-3"
                  name="email"
                  type="text"
                  readonly
                  v-model="user.username"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Password"
                label-for="password"
                class="text-left mx-auto col-12 col-lg-6"
                :class="
                  user.temporary_password || user.expired_password
                    ? 'text-danger'
                    : ''
                "
              >
                <b-button
                  type="submit"
                  variant="secondary mt-2 "
                  @click="$refs['modal-pswchange'].show()"
                  >{{$t('AccessoEPermessi.cambiaPassword')}}</b-button
                >
                <!-- <b-form-input
            class="my-3 "
            name="password"
            type="password"
            placeholder="password..."
            v-model="password"
            readonly
          ></b-form-input> -->
              </b-form-group>
            </div>
          </section>
        </div>
      </b-col>
      <b-col class="px-0 col-12 col-lgx-6">
        <div class="ml-lgx-2">
          <h3 class="mt-2 pt-4 text-left">
            <b-icon
              icon="clipboard-check"
              variant="secondary"
              font-scale="1.2"
              class="mr-1"
            ></b-icon>
            {{$t('AccessoEPermessi.terminiEPrivacy')}}
          </h3>
          <section
            class="bg-white general_border shadowedCard p-2 p-md-3 p-lg-4 mt-2"
          >
            <!-- <div
              v-if="user.type === 1"
              class="col-12 d-flex flex-wrap general_border"
            >
              <b-col>
                <p class="text-left">
                  <b-icon icon="check-circle-fill" variant="success"></b-icon>
                  Hai accettato le
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="infoLinks.operatore"
                  >
                    <u>Condizioni generali di contratto</u></a
                  >
                  e
                  <a
                    target="_blank"
                    class="text-underlined point"
                    href="https://concura.online/wp-content/uploads/2024/07/PP.pdf"
                  >
                    <u>{{$t('AccessoEPermessi.revocati1341')}}</u></a
                  >
                </p>
              </b-col>
              <b-col>
                <p class="text-left">
                  <b-icon icon="check-circle-fill" variant="success"></b-icon>
                  Hai accettato espressamente, ai sensi dell’articolo 1341 e ss
                  c.c. , le previsioni di cui agli articoli 8, 9, 10, 17, 18 del
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="infoLinks.operatore"
                  >
                    <u> Contratto</u></a
                  >
                </p>
              </b-col>
            </div>
            <div
              v-else-if="user.type === 0"
              class="col-12 d-flex flex-wrap general_border py-4"
            > -->
            <div class="col-12 d-flex flex-wrap general_border py-4">
              <b-col>
                <p class="text-left">
                  <span v-if="user.data_consense">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                    {{$t('AccessoEPermessi.visioneTermini')}}
                  </span>
                  <span v-else>
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                    {{$t('AccessoEPermessi.revocaTermini')}}
                  </span>
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="infoLinks.paziente"
                  >
                    <u>{{$t('AccessoEPermessi.titoloTermini')}}</u></a
                  >
                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="revocaConsensoPer('data_consense')"
                    >{{$t('AccessoEPermessi.modifica')}}</b-button
                  >
                </p>
              </b-col>
              <b-col>
                <p class="text-left">
                  <span v-if="user.charge_consense">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                    {{$t('AccessoEPermessi.visionePrivacy')}}
                  </span>
                  <span v-else>
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                    {{$t('AccessoEPermessi.revocaPrivacy')}}
                  </span>
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="
                      user.type == 1
                        ? privacyPolicyLinks.operatore
                        : privacyPolicyLinks.paziente
                    "
                  >
                    <u>{{$t('AccessoEPermessi.titoloPrivacy')}}</u></a
                  >
                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="revocaConsensoPer('charge_consense')"
                    >{{$t('AccessoEPermessi.modifica')}}</b-button
                  >
                </p>
              </b-col>
            </div>
            <b-row class="px-3">
              <b-col>
                <p class="text-left">
                  <span v-if="user.share_consense">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                    {{$t('AccessoEPermessi.visionati1341')}}
                  </span>
                  <span v-else>
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                    {{$t('AccessoEPermessi.revocati1341')}}
                  </span>
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="infoLinks.paziente"
                  >
                    <u>{{$t('AccessoEPermessi.titoloTermini')}}</u></a
                  >
                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="revocaConsensoPer('share_consense')"
                    >{{$t('AccessoEPermessi.modifica')}}</b-button
                  >
                </p>
              </b-col>
              <b-col>
                <p class="text-left mb-0">
                  <template v-if="user.marketing_consense">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                    {{$t('AccessoEPermessi.acconsentoComunicazioni')}}
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="
                        user.type == 1
                          ? privacyPolicyLinks.operatore
                          : privacyPolicyLinks.paziente
                      "
                    >
                      <u>{{$t('AccessoEPermessi.titoloPrivacy')}}</u></a
                    >
                  </template>
                  <template v-else>
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                    {{$t('AccessoEPermessi.nonAcconsentoComunicazioni')}}
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="
                        user.type == 1
                          ? privacyPolicyLinks.operatore
                          : privacyPolicyLinks.paziente
                      "
                    >
                      <u>{{$t('AccessoEPermessi.titoloPrivacy')}}</u></a
                    >
                  </template>
                  <b-button size="sm" class="ml-2" @click="startConsenseEdit"
                    >{{$t('AccessoEPermessi.modifica')}}</b-button
                  >
                </p>
              </b-col>
            </b-row>
          </section>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="edit_marketing_consense"
      :title="$t('AccessoEPermessi.titleConsensoComunicazioni')"
      size="lg"
      hide-footer
      centered
    >
      <b-form
        id="change_marketing_permission"
        @submit.prevent="onConsenseSubmit"
        class="px-4 py-2"
      >
        <b-row cols="1" class="text-left">
          <b-form-checkbox
            class="text-font-light-grey"
            name="marketing_consense"
            :value="true"
            :unchecked-value="false"
            v-model="consenseForm.marketing_consense"
          >
            <span class="text-dark"
              >{{$t('AccessoEPermessi.acconsento')}}
              <a
                target="_blank"
                class="text-underlined point"
                href="https://concura.online/wp-content/uploads/2024/07/PP.pdf"
              >
                <u>{{$t('AccessoEPermessi.titoloPrivacy')}}</u></a
              >
            </span>
          </b-form-checkbox>
          <b-form-checkbox
            class="text-font-light-grey"
            name="marketing_consense"
            :value="false"
            :unchecked-value="false"
            v-model="consenseForm.marketing_consense"
          >
            {{$t('AccessoEPermessi.nonAccetto')}}
          </b-form-checkbox>
        </b-row>
        <b-row class="justify-content-end mt-4 px-4">
          <b-button
            class="btn-popup-button ml-2 mr-0"
            @click="$bvModal.hide('edit_marketing_consense')"
            >{{$t('AccessoEPermessi.annulla')}}</b-button
          >
          <b-button class="btn-popup-button ml-2 mr-0" type="submit"
            >{{$t('AccessoEPermessi.salva')}}</b-button
          >
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      ref="modal-pswchange"
      :title="$t('AccessoEPermessi.titleModificaPassword')"
      size="lg"
      hide-footer
      centered
    >
      <b-form @submit.prevent="submitPswChange">
        <div class="col-12 d-flex flex-wrap">
          <b-form-group
            :label="$t('AccessoEPermessi.passwordAttuale')"
            label-for="oldpsw"
            class="text-left mx-auto col-12"
          >
            <b-form-input
              v-model="form.old_password"
              :placeholder="$t('AccessoEPermessi.placeholderAttuale')"
              class="my-3"
              name="oldpsw"
              :type="oldPasswordClear ? 'text' : 'password'"
              required
            ></b-form-input>
            <b-icon
              :icon="oldPasswordClear ? 'eye' : 'eye-slash'"
              font-scale="1.3"
              class="eye_icon point"
              @click="oldPasswordClear = !oldPasswordClear"
            ></b-icon>
          </b-form-group>
        </div>
        <div class="col-12 d-flex flex-wrap">
          <b-form-group
            label="Password*"
            label-for="password"
            class="text-left mx-auto col-12"
          >
            <b-form-input
              class="my-3"
              name="password"
              :type="passwordClear ? 'text' : 'password'"
              v-model="form.password"
              placeholder="Password..."
              :state="form.password == null ? null : validatePassword"
              required
            >
            </b-form-input>

            <b-icon
              :icon="passwordClear ? 'eye' : 'eye-slash'"
              font-scale="1.3"
              class="eye_icon point"
              @click="passwordClear = !passwordClear"
            ></b-icon>
          </b-form-group>
          <b-form-group
            :label="$t('AccessoEPermessi.confermaPassword')" 
            label-for="password"
            class="text-left mx-auto"
            :class="$root.isMobile ? '' : 'col'"
          >
            <b-form-input
              class="my-3"
              name="password_confirmation"
              :type="passwordConfirmationClear ? 'text' : 'password'"
              v-model="form.password_confirmation"
              :placeholder="$t('AccessoEPermessi.placeholderConferma')"
              :state="form.password == null ? null : validateConfirm"
              required
            ></b-form-input>

            <b-icon
              :icon="passwordConfirmationClear ? 'eye' : 'eye-slash'"
              font-scale="1.3"
              class="eye_icon point"
              @click="passwordConfirmationClear = !passwordConfirmationClear"
            ></b-icon>
          </b-form-group>
          <p class="text-left text-medium-grey fs-6">
            {{$t('AccessoEPermessi.requisitiPassword')}}
            <span
             v-b-tooltip :title="$t('AccessoEPermessi.tooltipCaratteri')"
              >{{$t('AccessoEPermessi.carattereSpeciale')}}</span
            >. {{$t('AccessoEPermessi.passwordDiversa')}}
          </p>
        </div>
        <div
          class="col-12 text-center d-flex justify-content-end my-3"
          :class="$root.isMobile ? 'flex-wrap' : ''"
        >
          <b-button
            type="button"
            class="mr-3"
            variant="popup-button"
            @click="resetForm"
            >{{$t('AccessoEPermessi.annullaOperazione')}}</b-button
          >
          <b-button
            type="submit"
            variant="popup-button"
            :disabled="!enableSecondBtn"
          >
            {{$t('AccessoEPermessi.confermaModifica')}}</b-button
          >
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="revoca_permesso"
      centered
      :title="revoca[revocaConsenso]"
      :ok-title="$t('AccessoEPermessi.siRevoca')"
      ok-variant="popup-button"
      :cancel-title="$t('AccessoEPermessi.noAnnulla')"
      cancel-variant="popup-button"
      footer-border-variant="white"
      @ok="submitRevoca"
      @cancel="$bvModal.hide('revoca_permesso')"
    >
      <h6>
        {{$t('AccessoEPermessi.revocaNecessaria')}}
      </h6>
      <p>{{$t('AccessoEPermessi.desideriRevoca')}}</p>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { cittadinoService } from "@/_services";

export default {
  name: "AccessoEPermessi",
  components: {},
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
    validatePassword() {
      if (this.form.password) {
        if (
          this.form.old_password &&
          this.form.old_password === this.form.password
        ) {
          return false;
        }
        this.has_minimum_lenth = this.form.password.length > 8;
        this.has_number = /\d/.test(this.form.password);
        this.has_lowercase = /[a-z]/.test(this.form.password);
        this.has_uppercase = /[A-Z]/.test(this.form.password);
        this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.form.password);
        // var regName = new RegExp(this.user.anagrafica.name);
        // var regSurname = new RegExp(this.user.anagrafica.surname);
        // this.has_name = !regName.test(this.form.password);
        // this.has_surname = !regSurname.test(this.form.password);
        const regName = new RegExp(this.user.anagrafica.name.toLowerCase());
        const regSurname = new RegExp(
          this.user.anagrafica.surname.toLowerCase()
        );
        this.has_name = !regName.test(this.form.password.toLowerCase());
        this.has_surname = !regSurname.test(this.form.password.toLowerCase());
        return (
          this.has_minimum_lenth &&
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_name &&
          this.has_surname &&
          this.has_special
        );
      }
      return false;
    },
    validateConfirm() {
      if (this.form.password) {
        return this.form.password_confirmation === this.form.password;
      }
      return false;
    },
    enableSecondBtn() {
      if (this.form.old_password !== null) {
        if (this.validatePassword && this.validateConfirm) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  data() {
    return {
      password: "password...",
      form: {
        old_password: null,
        password: null,
        password_confirmation: null,
      },
      infoLinks: {
        paziente: process.env.VUE_APP_LINK_TC_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_TC_OPERATORE,
      },
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE,
      },
      consenseForm: {
        marketing_consense: false,
      },
      oldPasswordClear: false,
      passwordClear: false,
      passwordConfirmationClear: false,
      revocaConsenso: null,
      revoca: {
        data_consense: this.$t('AccessoEPermessi.revoca.data_consense'),
        share_consense: this.$t('AccessoEPermessi.revoca.share_consense'),
        charge_consense: this.$t('AccessoEPermessi.revoca.charge_consense')
      }
    };
  },
  methods: {
    ...mapActions("utente", [
      "me",
      "changePassword",
      "setAnagrafica",
      "setTemporaryPasswordFalse",
      "setExpiredPasswordFalse",
    ]),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    resetForm() {
      this.$refs["modal-pswchange"].hide();
      this.form = {
        old_password: null,
        password: null,
        password_confirmation: null,
      };
    },
    submitRevoca() {
      var form = {};
      form[this.revocaConsenso] = false;
      const self = this;
      cittadinoService
        .updateConsense(form)
        .then(function (res) {
          self.me();
          self.$bvModal.hide("revoca_permesso");
          self.successAlert(self.$t('AccessoEPermessi.successModifica'));
          self.waitAndRedirect();
        })
        .catch(function (err) {
          self.$bvModal.hide("revoca_permesso");
          self.errorAlert(self.$t('AccessoEPermessi.erroreModifica'));
        });
    },
    waitAndRedirect() {
      const self = this;
      window.setTimeout(function () {
        self.$router.push({ name: "Home" });
      }, 3000);
    },
    submitPswChange() {
      const self = this;
      this.changePassword(this.form).then(function () {
        window.scrollTo(0, 0);
        self.resetForm();
        self.setTemporaryPasswordFalse();
        self.setExpiredPasswordFalse();
        self.me();
      });
    },
    revocaConsensoPer(consenso) {
      this.revocaConsenso = consenso;
      this.$bvModal.show("revoca_permesso");
    },
    startConsenseEdit() {
      this.consenseForm.marketing_consense = this.user.marketing_consense;
      this.$bvModal.show("edit_marketing_consense");
    },
    onConsenseSubmit() {
      const self = this;
      cittadinoService
        .updateConsense(this.consenseForm)
        .then(function (res) {
          self.me();
          self.$bvModal.hide("edit_marketing_consense");
          self.successAlert(self.$t('AccessoEPermessi.successModifica'));
        })
        .catch(function (err) {
          self.$bvModal.hide("edit_marketing_consense");
          self.errorAlert(self.$t('AccessoEPermessi.erroreModifica'));
        });
    },
  },
  watch: {},
  created() {
    this.me();
    if (this.$route.query.scope === "temporary") {
      this.$nextTick(function () {
        this.$refs["changePasswordDiv"].scrollIntoView();
        this.infoAlert(this.$t('AccessoEPermessi.modificaPasswordTemp'));
      });
    }
    if (this.$route.query.scope === "expired") {
      this.$nextTick(function () {
        this.$refs["changePasswordDiv"].scrollIntoView();
        this.infoAlert(this.$t('AccessoEPermessi.passwordScadutaCambio'));
      });
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
input.form-control:read-only {
  border-bottom: 1px solid darkgrey;
  border-radius: 0px !important;
  box-shadow: none !important;
  color: $body-color;
}

.eye_icon {
  position: absolute;
  right: 53px;
  top: 3.3rem;
  color: #9c9c9c;
}
</style>
